<template>
  <div class="rich-editor">
    <ckeditor
      v-if="show"
      :model-value="editorData"
      :disabled="disabled"
      @ready="onReady"
      :editor="editor"
      v-model="content"
      :config="editorConfig"
      @input="contentInput"
    ></ckeditor>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted, watch, onActivated } from "vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import HmdUploadAdapter from "./HmdUploadAdapter";
import _ from "lodash";
import { Form, message } from "ant-design-vue";
export default defineComponent({
  name: "RichEditor",
  props: {
    value: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    placeholderVal: { type: String, default: "" },
  },
  emit: ["update:value"],
  setup(props, { emit }) {
    const formItemContext = Form.useInjectFormItemContext();
    const editor = ClassicEditor;
    const content = ref("");
    const editorData = ref("");
    const show = ref(false);
    const editorConfig = ref({
      language: "zh-cn",
      toolbar: [
        "heading",
        "|",
        "fontFamily",
        "fontSize",
        "fontColor",
        "fontBackgroundColor",
        "|",
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "|",
        "alignment",
        "|",
        "numberedList",
        "bulletedList",
        "|",
        "indent",
        "outdent",
        "|",
        "link",
        "blockQuote",
        "imageUpload",
        "insertTable",
        "|",
        "undo",
        "redo",
      ],
      fontFamily: {
        options: ["宋体", "仿宋", "微软雅黑", "黑体", "仿宋_GB2312", "楷体", "隶书", "幼圆"],
      },
      placeholder: props.placeholderVal,
      image: {
        toolbar: [
          "imageTextAlternative",
          "imageStyle:inline",
          "imageStyle:block",
          "imageStyle:side",
        ],
      },
    });
    const contentInput = () => {
      emit("update:value", content.value);
    };
    // onMounted(() => {
    //   setTimeout(() => {
    //     content.value = _.cloneDeep(props.value);

    //     show.value = true;
    //   },500);
    // });

    const onReady = (editor) => {
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
      editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
        return new HmdUploadAdapter(loader);
      };
    };
    watch(
      () => content.value,
      (newValue, oldValue) => {
        if (newValue.length > 5000) {
          message.warning("限制文字输入5000字");
          return;
        }
        formItemContext.onFieldChange();
        // content.value = newValue;
      }
    );
    onMounted(() => {
      content.value = props.value;
      setTimeout(() => {
        content.value = _.cloneDeep(props.value);
        show.value = true;
      }, 500);
    });
    onActivated(() => {
      content.value = props.value;
      setTimeout(() => {
        content.value = _.cloneDeep(props.value);
        show.value = true;
      }, 500);
    });
    return {
      editor,
      editorConfig,
      onReady,
      content,
      editorData,
      contentInput,
      show,
    };
  },
});
</script>
<style lang="less">
// 编辑器高度，边框
.rich-editor {
  .ck-content {
    min-height: 300px;
    max-height: 500px;
    border: 1px solid #ccc !important;
    background-color: white;
  }
}
.ck.ck-editor__editable > .ck-placeholder::before {
  color: rgba(0, 0, 0, 0.45);
}
</style>
